import React from 'react';

import { Tooltip, Typography } from '@mui/material';

import { VoucherLog } from '~/services/PromoService';
import { formatDateLongMonthWithMeridiemNoSeconds } from '~/services/TimeService';

import { isVoucherLogProvideCredit } from '~/utils/voucherLogDisplayMode';

type Props = {
  row: VoucherLog;
};

/** Suffix for credit payout amounts: (pending) until credited, (paid) with grant date on hover. */
export default function ProvideCreditAmountStatus({ row }: Props) {
  if (!isVoucherLogProvideCredit(row)) {
    return null;
  }

  const grantedRaw = row.metadata?.creditGrantedAt;
  const grantedAt = typeof grantedRaw === 'string' ? grantedRaw.trim() : '';

  if (grantedAt) {
    return (
      <Tooltip title={formatDateLongMonthWithMeridiemNoSeconds(grantedAt)}>
        <Typography component="span" variant="body2" color="text.secondary" sx={{ cursor: 'help' }}>
          (paid)
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography component="span" variant="body2" color="text.secondary">
      (pending)
    </Typography>
  );
}
